// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAcWrP_qbt1y8esv4jvbeGNhZyDdGI-THk",
  authDomain: "hellocer-e2eb4.firebaseapp.com",
  projectId: "hellocer-e2eb4",
  storageBucket: "hellocer-e2eb4.firebasestorage.app",
  messagingSenderId: "378245580700",
  appId: "1:378245580700:web:489b2620e1e795e7636a59",
  measurementId: "G-X4GHK36NP9"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
